import { NEW_TEMPLATE_STEPS } from '@common/constants';
import {
  createHtmlStringWithConvertedDom,
  parseEachOnTbodyRecursive,
} from '@common/helpers/helpers';
import { SEVERITY_OPTIONS } from '@common/components/Notification/Notification';

const notify = (showNotifications, severity, message) => {
  showNotifications([
    {
      severity,
      message,
      show: true,
    },
  ]);
};

const notifySuccess = (showNotifications, message) =>
  notify(showNotifications, SEVERITY_OPTIONS.SUCCESS, message);

const notifyError = (showNotifications, message) =>
  notify(showNotifications, SEVERITY_OPTIONS.ERROR, message);

const buildUpdatedValues = (values) => {
  const newEditor = values?.editor?.map(
    ({ language, jsonData, HTMLdata, subject, ...rest }) => ({
      language: language,
      json_data: jsonData,
      HTMLdata: createHtmlStringWithConvertedDom(
        parseEachOnTbodyRecursive(HTMLdata),
      ),
      subject: subject || null,
      ...rest,
    }),
  );

  return {
    id: values?.id,
    name: values?.name,
    description: values?.description,
    source: values?.source,
    dataType: values?.dataType,
    type: values?.type,
    editor: newEditor,
    pdfAdditionalFields: values?.pdfAdditionalFields,
  };
};

const isDetailsStep = (step) => step === NEW_TEMPLATE_STEPS.DETAILS;

const isSubjectAndBodyStep = (step) =>
  step === NEW_TEMPLATE_STEPS.SUBJECT_AND_BODY;

const isPreviewStep = (step) => step === NEW_TEMPLATE_STEPS.PREVIEW;

export {
  notifySuccess,
  notifyError,
  buildUpdatedValues,
  isDetailsStep,
  isSubjectAndBodyStep,
  isPreviewStep,
};
